import type { RootState } from 'store'
import list from './mock/list.json'
import { getIsTutorialActive } from 'store/tutorial'

const selectRetailEShopsState = (state: RootState) => {
  const isTutrialActive = getIsTutorialActive(state)
  if (isTutrialActive) {
    return {
      items: list,
      pageInfo: {
        __typename: 'PageInfo',
        totalItems: 51200,
        totalPages: 2048,
        page: 1,
        perPage: 25,
        hasNextPage: true,
        hasPreviousPage: false,
      },
      sorting: {
        type: null,
        name: null,
        value: null,
      },
      loading: false,
      error: null,
      query: '',
      filters: [],
      selectedItems: [],
    }
  }
  return state?.retailEShops
}

export const getSort = (state: RootState) =>
  selectRetailEShopsState(state)?.sorting
export const getPageInfo = (state: RootState) =>
  selectRetailEShopsState(state)?.pageInfo ?? null
export const getLoading = (state: RootState) =>
  selectRetailEShopsState(state)?.loading
export const getError = (state: RootState) =>
  selectRetailEShopsState(state)?.error
export const getItems = (state: RootState) =>
  selectRetailEShopsState(state)?.items
export const getQuery = (state: RootState) =>
  selectRetailEShopsState(state)?.query ?? ''
export const getFilters = (state: RootState) =>
  selectRetailEShopsState(state)?.filters ?? []
export const getSelectedItems = (state: RootState) =>
  selectRetailEShopsState(state)?.selectedItems || []
